<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Dispatches">
    <ng-template matTabContent>
      <app-program-dispatches-index *ngIf="programs" [programs]="programs"></app-program-dispatches-index>
    </ng-template>
  </mat-tab>
  <mat-tab label="Programs">
    <ng-template matTabContent>
      <app-program-index *ngIf="programs" [programs]="programs" (newProgramEmitter)="processNewProgram($event)" (removedProgramEmitter)="processRemovedProgram($event)" automation-locator="programs-tab"></app-program-index>
    </ng-template>
  </mat-tab>
</mat-tab-group>
